import { Component, OnInit, Input} from '@angular/core';
import { AccountSettingService, OauthService,ProgramService, RedirectLoginDialogComponent } from '@terradotta/commons';
import { CookieService } from 'ngx-cookie';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'projects/loginRegistration/src/environments/environment';

declare var __ProgramId: number;
declare var __userId: number;
declare var __productLines: string;

@Component({
  selector: 'app-login-portal',
  templateUrl: './login-portal.component.html',
  styleUrls: ['./login-portal.component.scss']
})
export class LoginPortalComponent implements OnInit {
  @Input() primaryColor: string;
  @Input() tdSupportLogin: boolean = false;
  @Input() cycleItinerary: boolean = false;
  useTDSLogin: boolean = false;
  passwordReset: boolean = false;
  hidePassWord = true;
  tdLogin = true;
  tdRegistration = false;
  tdPasswordReset = false;
  formMode: string;
  programId: number = __ProgramId;
  productLines: string = __productLines;
  pId: number;
  isISSS: boolean = false;
  // Login Options
  loginRegistrationOptions: any;
  siteRegistrationOpen: boolean;
  requirePasswordMixedCase:  boolean;
  passwordMinCharLength: number;
  remoteLoginURL:  string;
  requirePasswordNumber:  boolean;
  // loginBackgroundImage: "8A7B4123-D8B8-B6A5-A4D869711A56D2AE",
  requirePasswordCharacter:  boolean;
  loginLogo: string = '';
  enableManualEntryOfHomeInst:  boolean;
  loginType: boolean = false;
  rcValue: any;
  isLoading: boolean = true;
  appCycleItinerary: boolean = false;
  userCanApply: boolean = false;
  appCycleLoading: boolean = true;
  ineligibleAppType: string;
  appExists: string;
  redirectURL: string;
  activeAppCycleResults: any;
  userId: number;
  userInfo: any;
  tempPW: string;
  institutionName: string = '';
  SCLEnabled: boolean;
  externalStudents: boolean;
  internalStudents: boolean;
  noInternalUser:boolean = false;
  // i18n
  i18nFields: any = {
    userLoginHelpText: 'Log in to get started.',
    userRegistrationHelpText: 'New user please complete the form below to create your account.',
    passwordResetHelpText: 'This is for non-Campus accounts only. If you need to reset your campus password please do to at the IT Support Password Manager.'
  };
  
  constructor(
    private _accountSettingService: AccountSettingService,
    private _oauthService: OauthService,
    private _cookieService: CookieService,
    private _programService: ProgramService,
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) {    
   }

  ngOnInit() {
    // this.clearExistingTDSCookie();
    if(this.productLines.includes('ISSS')){
      this.isISSS = true;
    }
    this._oauthService.getToken(true).then((token) => {
      if(token){
        if(this.cycleItinerary){
          this.userId = this.getUserId();
          this.route.queryParams.subscribe(data => {
            this.pId = data['Program_ID'];
          })      
          
          this._programService.getApplyAppCycles(this.pId, this.userId).subscribe(data => {
            this.activeAppCycleResults = data;
            this.appCycleItineraryReq(data);
            this.userFormChange('appCycleSelect');
            this.appCycleLoading = false;
          }, err => {
            if(err.status === 407){///407
              this.dialog.open(RedirectLoginDialogComponent, {
                disableClose: true
              });
            }
          })
        }
      }
    })
    // this.rcValue = 115  

    this.rcValue = this._cookieService.get('RC')    
    this.isLoading = true;
    if(this.programId > 0){
      var pi: number = this.programId
    } else {
    }
    this._oauthService.getLoginOptions(pi).subscribe(resp => {
      this.loginRegistrationOptions = resp;
      this.siteRegistrationOpen = resp.siteRegistrationOpen
      this.requirePasswordMixedCase = resp.requirePasswordMixedCase
      this.passwordMinCharLength = resp.passwordMinCharLength
      this.remoteLoginURL = resp.remoteLoginURL
      this.requirePasswordNumber = resp.requirePasswordNumber
      this.requirePasswordCharacter = resp.requirePasswordCharacter
      this.enableManualEntryOfHomeInst = resp.enableManualEntryOfHomeInst
      this.SCLEnabled = resp.SCLEnabled;
      this.externalStudents = resp.externalStudentsEnabled
      this.internalStudents = resp.internalStudentsEnabled
      if(this.SCLEnabled && !this.externalStudents){
        this.noInternalUser = true
      }
      this.loginType = resp.loginType
      this.loginLogo = resp.loginLogo      
      this.loadI18n(resp.i18n);
      this.isLoading = false;
      if(this.remoteLoginURL === '' && !this.cycleItinerary){
        this.useLocalTDSLoginForm();
      }
      if(this.cycleItinerary){
        this.appCycleItinerary = true;
      }
      this._accountSettingService.getByName('_sAccountInstitution','v2').subscribe(r => {
        if(r){
        this.institutionName = r.settingValue;
        }
      })
    }) 
  }

  getUserId(): any {
    if(environment.production){
      return __userId;
    } else {
      // for testing
      return 1000;//7292
    }
  }
  // clearExistingTDSCookie(){
  //   const cookieExists: any = this._cookieService.get('tds19');
  //   if(cookieExists){
  //     this._cookieService.remove('tds19',{secure:true,httpOnly:true})
  //   }
  // }
  useLocalTDSLoginForm(){
    this.useTDSLogin = !this.useTDSLogin
  }
  
  tdLoginRegistrationFormLoad() {
    this.tdLogin = !this.tdLogin;
    this.tdRegistration = !this.tdRegistration;
    this.tdPasswordReset = false;
  }
  userFormChange(formMode){
    if(formMode === 'pwReset'){
      this.passwordReset = true;
    } else {
      this.passwordReset = false;
    }
    if(formMode === 'newPassword'){
      this.useTDSLogin = false;
      this.tdPasswordReset = true;
    }
    if(formMode === 'userLogin'){
      this.useTDSLogin = true;
      this.tdPasswordReset = false;
    }
    if(formMode === 'appCycleSelect'){
      this.appCycleItinerary = true;
      this.useTDSLogin = false
      // this.appCycleItineraryReq()
    } else {
      this.appCycleItinerary = false;
    }
  }
  appCycleItineraryReq(activeAppCycleResults){
    if(activeAppCycleResults.existingApplicationData.length > 0 || activeAppCycleResults.userCanCreateApplication){//activeAppCycleResults.userCanCreateApplication
        this.userCanApply = true;
        this.activeAppCycleResults = activeAppCycleResults;
      }     
     else{
        this.ineligibleAppType = 'Your user type is not eligible to apply for this program. If you have any questions please contact our office.'
    }
    if(activeAppCycleResults.reasonForDenyingApplication !== ''){
      this.appExists = activeAppCycleResults.reasonForDenyingApplication;
      this.ineligibleAppType = '';
    }
  }
  passwordResetForm(pr){
    if(pr){
      this.useTDSLogin = false;
      this.tdPasswordReset = true;
      this.userInfo = pr;
    }
  }
  setRedirectURL(redirectURL){
    this.redirectURL = redirectURL;
  }
  setUserId(applicantUserId){
    this.userId = applicantUserId;
  }
  setTempPW(tempPW){
    this.tempPW = tempPW
  }

  loadI18n(i18n: any[]){
    i18n.forEach(item => {
      switch(item.id){
        case 10280:
          this.i18nFields.userLoginHelpText = item.word;
        break;
        case 10281:
          this.i18nFields.userRegistrationHelpText = item.word;
        break;
        case 10282:
          this.i18nFields.passwordResetHelpText = item.word;
        break;
        case 10283:
          this.i18nFields.ssoLoginButtonText = item.word;
        break;
        case 10284:
          this.i18nFields.tdsLoginButtonText = item.word;
        break;
      }
    });
  }  
}
